<script>
import axios from 'axios';
import Form from '../Form.vue';
import DialogManager from '../../services/DialogManager';

export default {
    extends: Form,

    methods: {
        async deleteCertificate() {
            try {
                await DialogManager.confirm(this.$t('masterfiles.institute.certificates.delete-confirmation'));
            } catch (error) {
                return;
            }

            await axios.delete(`/settings/institutes/certificates/${this.formData.uzi_certificate_id}`);
            this.formData.uzi_certificate_id = null;
        },

        confirmSkfPermission(checked) {
            if (!checked) {
                return;
            }

            DialogManager.confirm(this.$t('masterfiles.names.skf_permission_confirmation'))
                .then(() => {
                    this.formData.skf_automation_permission = true;
                })
                .catch(() => {
                    this.formData.skf_automation_permission = false;
                });
        },
    },
};
</script>
